import React from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import { Fields } from '../states/searchState';

type Props = {
  open: boolean;
  editTypeValue: string;
  editTypeList: { id: string, name: string }[];
  selectedField: Fields | undefined;
  role: string;
  handleRadioChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleClose: () => void;
  okEditTypeDialog: () => void;
};

export const EditTypeDialog: React.FC<Props> = (props) => {

  const createEditTypeRadio = (p: Array<{ id: string, name: string }>) => {
    const l = p.map((v, index) => {
      return (<FormControlLabel key={v.id} value={v.id} control={<Radio />} label={v.name} />)
    });
    if ((props.role === 'Manager' || props.role === 'Approver') && props.selectedField && props.selectedField.initdatafixicondisp && props.selectedField.initdatafixicondisp[0]) {
      l.push(<FormControlLabel key={'5'} value={'5'} control={<Radio />} label={'修正'} />);
    }
    return (<>{l}</>);
  }

  return (
    <Dialog
      open={props.open}
      keepMounted
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">{"編集種別を選択してください"}</DialogTitle>
      <DialogContent>
        <RadioGroup aria-label="gender" name="gender1" value={props.editTypeValue} onChange={props.handleRadioChange}>
          {props.editTypeList ? createEditTypeRadio(props.editTypeList) : 'null'}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.okEditTypeDialog} color="primary">
          Ok
        </Button>
        <Button onClick={props.handleClose} color="primary">
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  );
};
